module.exports = __webpack_public_path__ + "img/telegram-icon.85982358.svg";